import {useContext} from 'react'

import {UpmPlantsContext} from '../providers'
import type {UpmPlantsContextValue} from '../types'

export function useUpmPlantsContext(): UpmPlantsContextValue
export function useUpmPlantsContext(options?: {isInitialLoad: false}): UpmPlantsContextValue
export function useUpmPlantsContext(options?: {
  isInitialLoad: true
}): UpmPlantsContextValue | undefined
export function useUpmPlantsContext(options?: {isInitialLoad: boolean}) {
  const context = useContext(UpmPlantsContext)

  const isInitialLoad = !!options && options.isInitialLoad

  if (!context && !isInitialLoad) {
    throw new Error('useUpmPlantsContext is used outside of the UpmPlantsContext!')
  }

  return context
}
